import { AnswerType, ICategory } from "../models";

export const round94: ICategory[] = [
	{
		id: "1qxjjd4k1scs3a0",
		name: "Sing-a-long",
		answers: [
			{
				id: "1qxjjd4k1scs3a5",
				type: AnswerType.TEXT,
				answer:
					'Which movie does this lyric come from-- "And then i\'ll brush and brush and brush and brush my hair"?',
				question: "Rapunzel",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3aa",
				type: AnswerType.TEXT,
				answer: "Name a song from the Lion King",
				question:
					"Circle of Life, I Just Can't Wait to be King, Hakuna Matata, Can You Feel the Love Tonight, Be Prepared",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3af",
				type: AnswerType.TEXT,
				answer: "Song that Meg sings in Hercules when she is confused about her feelings.",
				question: "What is I won't say I'm in love?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ak",
				type: AnswerType.TEXT,
				answer: "What is the Song that Jasmine and Aladdin sing together?",
				question: "What is A Whole New World?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ap",
				type: AnswerType.TEXT,
				answer: "What is the name of the main song in Zootopia?",
				question: "Try Everything",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjjd4k1scs3a1",
		name: "Star Wars and Marvel",
		answers: [
			{
				id: "1qxjjd4k1scs3a6",
				type: AnswerType.TEXT,
				answer: "What is the name of the new Avengers movie?",
				question: "Avengers: Endgame",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ab",
				type: AnswerType.TEXT,
				answer: "What is the name of Star-Lord's ship in Guardians of the Galaxy?",
				question: "Milano",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ag",
				type: AnswerType.TEXT,
				answer: "What is the name of Han Solo's ship?",
				question: "Millennium Falcon",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3al",
				type: AnswerType.TEXT,
				answer: "What young Jedi Knight becomes Darth Vader in Star Wards?",
				question: "Anakin Skywalker",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3aq",
				type: AnswerType.TEXT,
				answer: "Where did Iron Man first face off against Whiplash? ",
				question: "Monaco",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjjd4k1scs3a2",
		name: "Pixar Movies",
		answers: [
			{
				id: "1qxjjd4k1scs3a7",
				type: AnswerType.TEXT,
				answer: "What animated feature film was Pixar's first release in 1995?",
				question: "Toy Story",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ac",
				type: AnswerType.TEXT,
				answer: 'The movie "WALL-E" features a robot of the same name. What is his job?',
				question: "Trash Collector",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ah",
				type: AnswerType.TEXT,
				answer:
					'What Pixar character says, "No matter how many times you save the world, it always manages to get back in jeopardy again?"',
				question: "Mr. Incredible",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3am",
				type: AnswerType.TEXT,
				answer: 'What European city is the setting for the 2007 movie "Ratatouille?" ',
				question: "Paris",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ar",
				type: AnswerType.TEXT,
				answer:
					'In the Oscar-winning movie "Up," where does character Carl Fredricksen move his house? ',
				question: "Paradise Falls",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjjd4k1scs3a3",
		name: "Princesses",
		answers: [
			{
				id: "1qxjjd4k1scs3a8",
				type: AnswerType.TEXT,
				answer: "Name the only Disney Princess based on a real life person. ",
				question: "Pocahontas ",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ad",
				type: AnswerType.TEXT,
				answer: "Name the only Disney Princess with hazel eyes. ",
				question: "Belle ",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ai",
				type: AnswerType.TEXT,
				answer: "Who are three princesses who had evil stepmothers? ",
				question: "Snow White, Cinderella, Rapunzel ",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3an",
				type: AnswerType.TEXT,
				answer: "Name the 2 Disney Princesses who have red hair.",
				question: "Princess Merida, Ariel (The Little Mermaid)",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3as",
				type: AnswerType.TEXT,
				answer: "What Disney princess movie was the first to show war?",
				question: "Mulan",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjjd4k1scs3a4",
		name: "Movies",
		answers: [
			{
				id: "1qxjjd4k1scs3a9",
				type: AnswerType.TEXT,
				answer:
					"What is the only Disney animated feature film that has a title character who doesn't speak?",
				question: "Dumbo",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ae",
				type: AnswerType.TEXT,
				answer: "Who was the first Disney princess?",
				question: "Snow White",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3aj",
				type: AnswerType.TEXT,
				answer: "Which character in Frozen likes warm hugs?",
				question: "Olaf",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ao",
				type: AnswerType.TEXT,
				answer: "Where do the lions live in the Lion King? ",
				question: "Pride Rock",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3at",
				type: AnswerType.TEXT,
				answer: "Name the 7 dwarfs",
				question: "Doc, Sleepy, Grumpy, Happy, Dopey, Sneezy, Bashful ",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	}
];
